import React from 'react';
import { Outlet } from 'react-router-dom';
import HelpDrawer from '../help/HelpDrawer.jsx';

// Shared body of the "_anonymous-web-layout*" shells: the raw shell carries no chrome,
// only the page content placeholder, so pages render straight through the outlet.
export default function AnonymousShell() {
  return (
    <div className="anonymous-shell">
      <HelpDrawer floating />
      <Outlet />
    </div>
  );
}
